import PropTypes from "prop-types";
import ReactPhoneNumberInput from "react-phone-number-input/input";
import { ValidationPropTypes } from "../constants";
import { useDebouncedCallback } from "../hooks/useDebouncedCallback";
import { useStoreActions, useStoreSelectors, useStoreState } from "../store";

export function PhoneInput({ inputData }) {
  const { selectInputStyle, selectCanAdvance } = useStoreSelectors();
  const { changeInput, blurInput, navigateForward } = useStoreActions();
  const { settings } = useStoreState();
  const inputStyle = selectInputStyle();
  const isPristine = !Object.prototype.hasOwnProperty.call(inputData.validation, "isValid");
  const isValid = inputData.validation.isValid;
  const isTouched = inputData.isTouched;

  let classes = `phone-input w-full rounded border p-3 shadow shadow-gray-100 mt-2 appearance-none outline-none text-neutral-800 col-auto xxs:col-span-2 ${
    (!isPristine && isTouched && !isValid) ? "border-red-500" : "border-gray-300"
  }`;

  if (inputStyle === "square") {
 
    classes = `phone-input w-full p-5 placeholder-grey-dark text-base uppercase font-bold mb-2 tracking-wider text-center animate-slideLeft ${
 
      (!isPristine && isTouched && !isValid)
        ? "outline-pink-error outline-2 outline-offset-4 outline-dashed"
        : "outline-gray-300 outline-2 outline-offset-1 focus:outline-dashed"
    }`;
  }

 
  const errorClasses = settings.inputErrorClass ?? "text-red-500";
 

  // Updates the input value when typing.
  const handleInputChange = useDebouncedCallback((value) => {
    changeInput({ name: inputData.name, value });
  }, 250);

  // Trigger validation when the user leaves the input.
  const handleInputBlur = () => {
    blurInput({ name: inputData.name });
  };

  const handleInputKeyDown = useDebouncedCallback((event) => {
    if (event.key === "Enter" && selectCanAdvance()) {
      navigateForward();
    }
  }, 250);

  return (
    <>
      {inputData.label && <div className="font-bold mb-4 mt-4 text-xl">{inputData.label}</div>}
      <ReactPhoneNumberInput
        type="tel"
        autoComplete="tel-national"
        defaultCountry="US"
        name={inputData.name}
        value={inputData.value}
        placeholder={inputData.placeholder}
        aria-label={inputData.placeholder}
        className={`${classes}`}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        onKeyDown={handleInputKeyDown}
      />
      {isTouched && !isValid && (
        <div className={`mt-2 text-sm ${errorClasses}`}>
          {inputData.validation.error}
        </div>
      )}
    </>
  );
}

PhoneInput.propTypes = {
  inputData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    validation: ValidationPropTypes,
  }),
};
